export type MsgStatus = 'sent' | 'delivered' | 'read';
const STATUS_RANK: Record<MsgStatus, number> = { sent: 0, delivered: 1, read: 2 };

/** Поздний ack не должен отменять уже полученное прочтение или доставку. */
export function upgradeStatus(prev: Map<number, MsgStatus>, id: number, status: MsgStatus): Map<number, MsgStatus> {
  const current = prev.get(id);
  if (current && STATUS_RANK[current] >= STATUS_RANK[status]) return prev;
  return new Map(prev).set(id, status);
}

/** Положительный ID из истории/REST/WS подтверждает приём сервером. */
export function messageStatus(id: number, receipt?: string): 'waiting' | MsgStatus {
  if (receipt === 'read' || receipt === 'delivered' || receipt === 'sent') return receipt;
  return id > 0 ? 'sent' : 'waiting';
}
